/**
 * A CTA button that toggles the audio file on and off.
 * @author Dayne Coulson-Hoffacker
 */
export default class AudioToggle {
  /**
   * Constructs a new AudioToggle CTA.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.audio = this.element.querySelector('audio')

    // Enable play toggle button
    this.element.addEventListener('click', () => {
      this.element.classList.toggle('playing')
      this.togglePlay()
    })

  }

  /**
   * Toggles audio play/pause.
   * @param {Boolean} [toggle] - Should the video play or pause.
   */
  togglePlay (toggle = this.audio.paused) {
    toggle ? this.audio.play() : this.audio.pause()
  }

}



// WEBPACK FOOTER //
// ./components/audio-toggle/index.js